<template>
  <el-dialog
    title="申请申述"
    :visible.sync="dialogVisible"
    width="1000px"
    class="dialog"
  >
    <el-tabs v-model="activeName">
      <el-tab-pane label="提交申述" name="first">
        <el-form :model="form" label-width="100px" class="dialog-form">
          <el-form-item label="订单编号" class="margin-bottom-0">
            {{ data.orderCode }}
          </el-form-item>
          <el-form-item label="仪器名称" class="margin-bottom-10">
            {{ data.checkmallWaresName }}
          </el-form-item>
          <el-form-item label="申请申述内容">
            <el-input
              v-model="form.applyAppealContent"
              type="textarea"
              :rows="5"
              resize="none"
              :maxlength="400"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="flex flex-right">
          <el-button
            type="primary"
            @click="submitBtn"
            :loading="loading"
            size="small"
            >提 交</el-button
          >
        </div>
      </el-tab-pane>
      <el-tab-pane label="查看申请结果" name="second">
        <div class="ask">
          <div v-for="(item, index) in results" :key="index" class="ask-item">
            <div class="flex">
              <div>申请申述：</div>
              <div class="ask-con flex-1">{{ item.applyAppealContent }}</div>
            </div>
            <div class="ask-createTime">
              <div>申述时间：{{ item.createTime }}</div>
            </div>
            <div class="flex">
              <div>申述结果：</div>
              <div :class="{ [statusClass[+item.applyAppealStatus]]: true }">
                {{ applyStatusMap[+item.applyAppealStatus] }}
              </div>
            </div>
            <div class="flex ask-list" v-if="!!+item.applyAppealStatus">
              <div>处理时间：</div>
              <div>{{ item.updateTime }}</div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>
<script>
import { toAskFor } from "@/api/userCenter";
import { askForResult } from "@/api/userCenter";
import { APPLY_APPEAL_STATUS } from "@/constant/dict";
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    dialogVisible: {
      get: function () {
        return this.value;
      },
      set: function (val) {
        this.$emit("input", val);
      },
    },
  },
  data() {
    return {
      activeName: "first",
      form: {
        applyAppealContent: "",
      },
      loading: false,
      results: [],
      statusClass: {
        0: "no",
        1: "yes",
      },
      applyStatusMap: {},
    };
  },
  created() {
    this.getResult();
  },
  methods: {
    async submitBtn() {
      this.loading = true;
      await this.$axios
        .post(toAskFor, {
          ...this.form,
          orderId: this.data.checkmallOrderMainId,
          mallOrderType: 0, // 商城订单类别 0:严选商城，1：优选商城
        })
        .finally(() => {
          this.loading = false;
        });
      this.$message.success("提交成功");
      this.dialogVisible = false;
    },
    async getResult() {
      const status = await this.$store.dispatch(
        "getDictData",
        APPLY_APPEAL_STATUS
      );
      const map = {};
      status.forEach((item) => {
        map[item.dictValue] = item.dictLabel;
      });
      this.applyStatusMap = map;
      const res = await this.$axios.get(askForResult, {
        orderId: this.data.checkmallOrderMainId,
      });
      this.results = res;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.margin-bottom-0 {
  margin-bottom: 0;
}
.margin-bottom-10 {
  margin-bottom: 10px;
}
.dialog {
  /deep/ .el-dialog__body {
    padding: 0 20px 20px 20px;
  }
  &-form {
    height: 318px;
  }
}
.ask {
  padding: 0 20px;
  height: 350px;
  overflow: auto;
  &-item {
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 2px dashed $border-color;
  }
  &-con {
    border: 1px solid $border-color;
    padding: 5px 10px;
    border-radius: 5px;
    min-height: 50px;
    margin-bottom: 3px;
  }
  &-createTime {
    text-align: right;
    color: #999;
    font-size: 0.85rem;
    margin-bottom: 10px;
  }
}
div.no {
  color: #f56c6c;
}
div.yes {
  color: #67c23a;
  margin-bottom: 10px;
}
</style>
